import api, { unwrap, errorMessage } from './client';

export async function myReports() {
  return unwrap(await api.get('/reports/my'));
}

export async function getReport(id) {
  return unwrap(await api.get(`/reports/${id}`));
}

export async function listAdminReports(params = {}) {
  return unwrap(await api.get('/admin/reports', { params }));
}

export function reportFileUrl(id, opts = {}) {
  const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1';
  return `${base}/reports/${id}/file${opts.inline ? '?inline=1' : ''}`;
}

// Auth-aware download via blob (so the JWT header is sent).
export async function downloadReportFile(id, suggestedName = 'report') {
  try {
    const res = await api.get(`/reports/${id}/file`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = suggestedName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  } catch (err) {
    throw new Error(errorMessage(err));
  }
}
